import React from "react";
import { MemoryRouter, Routes, Route } from "react-router-dom";
import TrackSelection from "../TrackSelection";
import { ROUTES } from "../../consts";
import { SelectAgeGroup, SelectDateTime, SelectRaceTypes, SelectSeatsRaces, ReviewExperience, MainCart } from "../MainTrack";
import { MiniSelectSeatsRaces, MiniSelectDateTime, MiniReviewExperience, MiniCart } from "../MiniTrack";
import { VRSelectPlayerAndSessions, VRSelectTimeslots, VRCustomizeGame, VRReviewExperience, VRCart } from "../VirtualReality";
import { ArcadeCard, ArcadeExperience, ArcadeCart } from "../Arcade";
import JuniorTrack from "../JuniorTrack";
import JuniorTrackSelectSeatsRaces from "../JuniorTrack/subComponents/SelectSeatsRaces";
import JuniorTrackReviewExperience from "../JuniorTrack/subComponents/ReviewExperience";
import JuniorTrackCart from "../JuniorTrack/subComponents/ReviewCart";
import BattleKartPlayersAndSessions from "../battleKart/subComponents/playersAndSessions";
import BattleKart from "../battleKart";

import BattleKartReviewCart from "../battleKart/subComponents/ReviewCart";

const NewUI: React.FC = () => {
  return (
    <>
      <MemoryRouter initialEntries={[ROUTES.INDEX]}>
        <Routes>
          <Route path={ROUTES.INDEX} element={<TrackSelection />} />
          {/* MAIN TRACK ROUTES */}
          <Route path={ROUTES.MAIN_TRACK.AGE_GROUP} element={<SelectAgeGroup />} />
          <Route path={ROUTES.MAIN_TRACK.RACE_TYPE} element={<SelectRaceTypes />} />
          <Route path={ROUTES.MAIN_TRACK.SEATS_RACES} element={<SelectSeatsRaces />} />
          <Route path={ROUTES.MAIN_TRACK.DATE_TIME} element={<SelectDateTime />} />
          <Route path={ROUTES.MAIN_TRACK.BOOKING_SUMMARY} element={<ReviewExperience />} />
          <Route path={ROUTES.MAIN_TRACK.ReviewCart} element={<MainCart />} />
          {/* JUNIOR TRACK ROUTES */}
          <Route path={ROUTES.JUNIOR_TRACK.SEATS_RACES} element={<JuniorTrackSelectSeatsRaces />} />
          <Route path={ROUTES.JUNIOR_TRACK.DATE_TIME} element={<JuniorTrack />} />
          <Route path={ROUTES.JUNIOR_TRACK.BOOKING_SUMMARY} element={<JuniorTrackReviewExperience />} />
          <Route path={ROUTES.JUNIOR_TRACK.ReviewCart} element={<JuniorTrackCart />} />
          {/* BATTLE KART TRACK ROUTES */}
          <Route path={ROUTES.BATTLE_KART_TRACK.PLAYERS_SESSIONS} element={<BattleKartPlayersAndSessions />} />
          <Route path={ROUTES.BATTLE_KART_TRACK.DATE_TIME} element={<BattleKart />} />
          <Route path={ROUTES.BATTLE_KART_TRACK.ReviewCart} element={<BattleKartReviewCart />} />
          {/* MINI TRACK ROUTES */}
          <Route path={ROUTES.MINI_TRACK.SEATS_RACES} element={<MiniSelectSeatsRaces />} />
          <Route path={ROUTES.MINI_TRACK.DATE_TIME} element={<MiniSelectDateTime />} />
          <Route path={ROUTES.MINI_TRACK.BOOKING_SUMMARY} element={<MiniReviewExperience />} />
          <Route path={ROUTES.MINI_TRACK.ReviewCart} element={<MiniCart />} />
          {/* VIRTUAL REALITY ROUTES */}
          <Route path={ROUTES.VIRTUAL_REALITY.PLAYERS_SESSIONS} element={<VRSelectPlayerAndSessions />} />
          <Route path={ROUTES.VIRTUAL_REALITY.DATE_TIME} element={<VRSelectTimeslots />} />
          <Route path={ROUTES.VIRTUAL_REALITY.CUSTOMIZEGAME} element={<VRCustomizeGame />} />
          <Route path={ROUTES.VIRTUAL_REALITY.BOOKING_SUMMARY} element={<VRReviewExperience />} />
          <Route path={ROUTES.VIRTUAL_REALITY.ReviewCart} element={<VRCart />} />
          {/* ARCADE ROUTES */}
          <Route path={ROUTES.ARCADE.ARCADE_CARD} element={<ArcadeCard />} />
          <Route path={ROUTES.ARCADE.ARCADE_EXPERIENCE} element={<ArcadeExperience />} />
          <Route path={ROUTES.ARCADE.ARCADE_CART} element={<ArcadeCart />} />
        </Routes>
      </MemoryRouter>
    </>
  );
};

export default NewUI;
